import { group } from "@angular/animations";
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { DomainConfigComponent } from "@app/domain-config.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomfilterComponent } from "../pop-up/customfilter/customfilter.component";
import { BatchAssigmentUserComponent } from "../pop-up/batch-assigment-user/batch.assigment.user.component";
import { BatchDeleteRequirementComponent } from "../pop-up/batch-delete-requirement/batch-delete-requirement.component";
import { BatchScrapingToggleConfirmComponent } from "../pop-up/batch-scraping-toggle-confirm/batch-scraping-toggle-confirm.component";
import { BatchReturnRequirementDialogComponent } from "@app/trackvision/requirement/batch-return-requirement-dialog/batch-return-requirement-dialog.component";
import { BatchRequirementService } from "@services/bathupdaterequirement.service";
import { BatchAssingRequirementDialogComponent } from "@app/trackvision/requirement/batch-assing-requirement-dialog/batch-assing-requirement-dialog.component";
import { BatchCollaboratorRequirementDialogComponent } from "@app/trackvision/requirement/batch-collaborator-requirement-dialog/batch-collaborator-requirement-dialog.component";
import { BatchChangeStatusRequirementDialogComponent } from "@app/trackvision/requirement/batch-change-state-requirement-dialog/batch-change-state-requirement-dialog.component";
import { ChangeRequesterDialogComponent } from "@app/trackvision/requirement/change-requester-dialog/change-requester-dialog.component";
import { openPjudAlertModal, toPjudUserMessage } from "src/app/util/pjud-user-message";

@Component({
    selector: "app-batchupdaterequirement",
    templateUrl: "./batchupdaterequirement.component.html",
    styleUrls: ["./batchupdaterequirement.component.scss"],
    standalone: false
})
export class BatchUpdateRequirementComponent implements OnInit {

  @Output() deleting = new EventEmitter();
  @Output() returning = new EventEmitter();
  @Output() assigment = new EventEmitter();



  @Input() requirementTypes: any[];
  @Output() customSelected = new EventEmitter<{ id: number, name: string }>();
  @Input() selectedIds: number[];
  /** Mostrar opciones Activar/Desactivar seguimiento PJUD (según config del tipo) */
  @Input() showScrapingToggle = false;

  isSubMenuVisible = false;

  constructor(
    public domainConfigComponent: DomainConfigComponent,
    private modalService: NgbModal,
    private batchRequirementService: BatchRequirementService
  ) {

  }

  ngOnInit() {
  }

  subMenuVisible = false;

  openMainMenu() {
    const menu = document.getElementById('masMenu');
    if (menu) {
      menu.classList.add('show');
      const dropdownMenu = menu.nextElementSibling;
      if (dropdownMenu) {
        dropdownMenu.classList.add('show');
      }
    }
  }

  closeMainMenu() {
    const menu = document.getElementById('masMenu');
    if (menu) {
      menu.classList.remove('show');
      const dropdownMenu = menu.nextElementSibling;
      if (dropdownMenu) {
        dropdownMenu.classList.remove('show');
      }
    }
    this.subMenuVisible = false;
  }

  openSubMenu() {
    this.subMenuVisible = true;
  }

  closeSubMenu() {
    this.subMenuVisible = false;
  }

  emitCustomEvent(event: Event, id: number, name: string) {
    event.preventDefault();
    this.customSelected.emit({ id, name });
  }

  openAssigmentModal() {
    const modalRef = this.modalService.open(BatchAssingRequirementDialogComponent, { scrollable: true, size: 'md', backdrop: 'static', keyboard: false });
    modalRef.componentInstance.requirementIds = this.selectedIds;
    modalRef.componentInstance.assigned.subscribe(assigned => {
      if (assigned) {
        this.assigment.emit(true);
        modalRef.close();
        window.location.reload();
      }
    });
  }

  deleteRequirements() {
    const modalRef = this.modalService.open(BatchDeleteRequirementComponent, {
      size: 'md', backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.requirementIds = this.selectedIds;
    modalRef.componentInstance.title = 'Requerimientos';
    modalRef.componentInstance.deleteFile.subscribe((deleteFile) => {
      if (deleteFile) {
        const body = {
          requirementids: this.selectedIds
        };
        this.batchRequirementService.deleteRequirements(body).subscribe({
          next: (resp) => {
            console.log('trackvision/batchupdaterequirement/delete', resp);
            modalRef.close();
            this.deleting.emit(true);
          },
          error: (err) => {
            modalRef.componentInstance.loading = false;
            alert(
              err?.error?.message ||
                err?.message ||
                'Error al eliminar requerimientos.'
            );
          },
        });
      }
    });
  }


  return() {
    const modalRef = this.modalService.open(BatchReturnRequirementDialogComponent, {
      centered: true, backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.requirementIds = this.selectedIds;
    modalRef.componentInstance.returned.subscribe(returned => {
      if(returned){
        this.returning.emit(true);
        modalRef.close();
        window.location.reload();
      }
    });
  }


  changestatus() {
    const modalRef = this.modalService.open(BatchChangeStatusRequirementDialogComponent, {
      centered: true, backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.requirementIds = this.selectedIds;
    modalRef.componentInstance.returned.subscribe(returned => {
      if(returned){
        this.returning.emit(true);
        modalRef.close();
        window.location.reload();
      }
    });
  }

  setCollaborator() {
    const modalRef = this.modalService.open(BatchCollaboratorRequirementDialogComponent, {
      centered: true, backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.requirementIds = this.selectedIds;
    modalRef.componentInstance.returned.subscribe(returned => {
      if(returned){
        this.returning.emit(true);
        modalRef.close();
        window.location.reload();
      }
    });

  }

  openChangeRequesterDialog() {
    const modalRef = this.modalService.open(ChangeRequesterDialogComponent);
    modalRef.componentInstance.requirementIds = this.selectedIds;
    modalRef.componentInstance.changed.subscribe((result) => {
      if (result) {
        this.returning.emit(true);
        modalRef.close();
        window.location.reload();
      }
    });
  }

  openScrapingToggle(enabled: boolean) {
    this.closeMainMenu();
    const modalRef = this.modalService.open(BatchScrapingToggleConfirmComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.enabled = enabled;
    modalRef.componentInstance.count = this.selectedIds.length;
    modalRef.componentInstance.requirementIds = this.selectedIds;
    modalRef.componentInstance.applyToggle.subscribe(() => {
      this.batchRequirementService
        .scrapingToggle({
          requirementIds: this.selectedIds,
          enabled
        })
        .subscribe({
          next: (resp) => {
            modalRef.close();
            const body = (resp as any)?.result ?? resp;
            const failed = body?.results?.filter((r: any) => !r.success) || [];
            const ok = body?.results?.filter((r: any) => r.success) || [];
            const rawBackendMsg = body?.message;
            const msgBackend = rawBackendMsg ? toPjudUserMessage(rawBackendMsg) : undefined;
            if (failed.length > 0 && ok.length === 0) {
              const rawDetail = failed.map((r: any) => r.message).join(' ');
              const detail = failed
                .map((r: any) => `Req. ${r.requirementId}: ${toPjudUserMessage(r.message)}`)
                .join('<br>');
              openPjudAlertModal(
                this.modalService,
                msgBackend || detail || 'No se pudo aplicar el seguimiento PJUD.',
                { rawMessage: rawBackendMsg || rawDetail }
              );
            } else if (failed.length > 0) {
              const rawDetail = failed.map((r: any) => r.message).join(' ');
              const detail = failed
                .map((r: any) => `Req. ${r.requirementId}: ${toPjudUserMessage(r.message)}`)
                .join('<br>');
              openPjudAlertModal(
                this.modalService,
                msgBackend || `Aplicado a ${ok.length} requerimiento(s). Algunos no aplican:<br>${detail}`,
                { rawMessage: rawBackendMsg || rawDetail }
              );
            } else {
              openPjudAlertModal(
                this.modalService,
                `Seguimiento PJUD ${enabled ? 'activado' : 'desactivado'} para ${ok.length} requerimiento(s).`
              );
            }
            this.returning.emit(true);
          },
          error: err => {
            modalRef.componentInstance.loading = false;
            const rawMsg = err?.error?.result?.message || err?.error?.message || err?.message;
            const msg = toPjudUserMessage(rawMsg, 'Error al actualizar seguimiento PJUD.');
            openPjudAlertModal(this.modalService, msg, { rawMessage: rawMsg });
          }
        });
    });
  }

}
